import { em } from 'polished'
import styled from 'styled-components'

import { Text } from 'styles/components/typography'

export const BaseWrapper = styled.div`
  color: ${p => p.theme.colors.white};
  display: grid;
  grid-template-areas:
    'content content'
    'dna wgs';
  grid-template-columns: 1fr 1fr;
  grid-template-rows: ${em(230)} 1fr;
  margin-bottom: ${em(50)};
`

export const Content = styled.div`
  grid-area: content;
  text-align: center;
`

export const TextStyled = styled(Text)`
  max-width: ${em(300)};
  margin: 0 auto;
`

export const BaseBoxWrapper = styled.div`
  grid-area: ${p => p.productType};
  align-self: center;
`
